import { Enums } from "../../models/common/enums"
import { OpTariff } from "../../models/core/op-tariff"
import { OpLocation } from "../../models/core/op-location"
import { ColumnModel } from "../../modules/api/api.models"

import { TariffService, TARIFF_SERVICE_NAME } from './tariff.service'
import { GridService, GRID_SERVICE_NAME } from '../grid/grid.service'


// #region Consts

export const TARIFF_LOCATIONS_SERVICE_NAME: string = 'TariffLocationsService'
export const TARIFF_LOCATIONS_SERVICE_PROVIDER_NAME: string = 'TariffLocationsServiceProvider'

// #endregion

export class TariffLocationsService {

    // #region Consts

    public static get LOG_PREFIX(): string { return '[SIMAX.Services.Tariff.Locations]' }

    // #endregion


    // region Ctor

    public constructor(
        private tariffService: TariffService,
        private gridService: GridService
    ) { }

    //#endregion


    // region Save

    public saveTariffLocations(moduleName: Enums.SimaxModuleName, tariff: OpTariff, added: any[], removed: any[]): JQueryPromise<OpTariff> {
        const newLocations: OpLocation[] = added.map((newLocationData: any) => {
            const location: OpLocation = new OpLocation(null)

            location.idLocation = newLocationData.id
            location.opState = Enums.OpChangeState.New

            return location
        })

        const removedLocations: OpLocation[] = removed.map((removedLocationData: any) => {
            const location: OpLocation = new OpLocation(null)

            location.idLocation = removedLocationData.id
            location.opState = Enums.OpChangeState.Delete

            return location
        })

        const removedLocationIds: number[] = removedLocations.map((removedLocation: OpLocation) => removedLocation.idLocation)

        const loadedLocations: OpLocation[] = tariff.currentLocations
            .filter((loadedLocation: OpLocation) => removedLocationIds.indexOf(loadedLocation.idLocation) == -1)
            .map((loadedLocation: OpLocation) => {
                const location: OpLocation = new OpLocation(null)

                location.idLocation = loadedLocation.idLocation
                location.opState = Enums.OpChangeState.Loaded

                return location
            })

        const objectToSave: OpTariff = new OpTariff(null)

        objectToSave.idTariff = tariff.idTariff
        objectToSave.opState = Enums.OpChangeState.Modified
        objectToSave.currentLocations = [].concat(...loadedLocations, ...newLocations, ...removedLocations)

        return this.tariffService.saveTariff(objectToSave, moduleName)
    }

    //#endregion


    public getTariffLocationsParameters(): JQueryPromise<ColumnModel[]> {
        return this.gridService.getColumnModelByCategory(
                Enums.SimaxDataTypeGroupCategory.WEBSIMAX__MODULE_NAME__LOCATION_GRID_PARAMS,
                Enums.SimaxModuleName.Tariff,
                { viewReferenceType: Enums.ReferenceType.IdLocation }
            )
    }

}


export class TariffLocationsServiceProvider implements ng.IServiceProvider {

    // #region IServiceProvider Implementation 

    public $get = [
        TARIFF_SERVICE_NAME,
        GRID_SERVICE_NAME,
        function (
            tariffService: TariffService,
            gridService: GridService
        ) {
            return new TariffLocationsService(tariffService, gridService)
        }]

    // #endregion
} 
